import React, { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import fetch from 'isomorphic-unfetch'

// Components
import { Seo, Footer } from '../../components'

// Styled Components
import { PageWrapper, ContentWrapper } from '../../styles/layout'

import pgContent from './content.md'

const HowTo = () => {
  const [content, setContent] = useState(null)

  const fetchContent = async () => {
    const response = await fetch(pgContent)
    const text = await response.text()
    setContent(text)
  }

  useEffect(() => {
    fetchContent()
  }, [])

  return (
    <PageWrapper>
      <Seo
        title="How To"
        slug="how-to"
        keywords={['how', 'usage', 'explanation', 'quickstart']}
        description="Learn how to create SVG drawing animations in SVG Artista in three simple steps."
      />

      {/* Main Content */}
      <ContentWrapper
        className="page-content"
        as={ReactMarkdown}
        source={content}
        escapeHtml={false}
        linkTarget={url => url.match(/https?:\/\//) && '_blank'}
        // linkTarget={(url, text, title) => url.match(/https?:\/\//) && '_blank'}
      />

      {/* Footer */}
      <Footer />
    </PageWrapper>
  )
}

export default HowTo
